var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"flat":"","color":"transperant","data-testid":"page-header"}},[_c('v-card-text',{staticClass:"px-0 py-2 pb-4",attrs:{"data-testid":"page-header__card-text"}},[_c('span',{staticClass:"text-h4 py-3 grey--text text--darken-2",attrs:{"data-testid":"page-header__title"}},[_vm._v(_vm._s(_vm.props.name || ""))]),_c('v-spacer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }